// 将对象转换成 url参数 ： a=xxx&b=xxx 这样的字符串
export function paramToStr(params = {}) {
    let paramArray = [];
    let keys = Object.keys(params);

    for (let i = 0; i < keys.length; i++) {
        let key = keys[i];
        if (params[key] !== undefined) {
            paramArray.push(`${key}=${params[key]}`);
        }
    }
    return paramArray.join('&');
}

/**
 * 包装一个函数，在一定时间里触发了一定次数之后，才触发
 * @param count 次数
 * @param wait 时长
 * @param func 触发的方法
 * @param context 上下文
 */
export function repeatAfter(count, wait, func, context = null) {
    let timer = null;
    let num = 0;
    return function(...args) {
        // 清空timer
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        // 增加数量
        num++;
        console.log(`tap num --> ${num}`);
        if (num >= count) {
            func.apply(context, args);
        }

        // 多少秒后还未进入就清0
        timer = setTimeout(() => {
            num = 0;
        }, wait);
    };
}

// 从 location.search 中获取 query 参数
export function getQuery(search) {
    var queryObj = new Object();
    if (search.indexOf('?') != -1) {
        var params = search.substr(1);
        params = params.split('&');
        for (var i = 0; i < params.length; i++) {
            let query = params[i].split('=');
            queryObj[query[0]] = query[1];
        }
    }
    return queryObj;
}

/**
 * 打开页面
 * to : { path , query }
 * 注意： 不支持 params
 */
export function getFullUrl(to) {
    let routeObj = { ...to };
    const origin = window.location.origin;
    const pathName = window.location.pathname;
    let link = `${origin}${pathName}?ZZCAppArg=AppOpenPage#${routeObj.path}`;
    let query = to.query || {};
    let queryStr = paramToStr(query);
    if (queryStr) {
        link += `?${queryStr}`;
    }
    return link;
}

/**
 * 是否ios
 */
export function isIos() {
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    return iOS;
}

//判断是否使用微信app支付
//iosMinVersion 最低兼容版本 格式1.3.0
//androidMinVersion 最低兼容版本 格式1.5.0
export function isGreaterVersion({ iosMinVersion, androidMinVersion }) {
    let minVersion;
    let ua = window.navigator.userAgent;
    let isIos = /ZZCIOS\/black/.test(ua);
    let isAndroid = /ZZCAndroid\/black/.test(ua);
    if (isIos) {
        minVersion = iosMinVersion;
    } else if (isAndroid) {
        minVersion = androidMinVersion;
    } else {
        return false;
    }
    let minVersionArray = minVersion.split('.');
    let versionArray =
        ua
            .split('(')[0]
            .split('/')[2]
            .split('.') || [];
    if (Number(versionArray[0]) > minVersionArray[0]) {
        return true;
    } else if (Number(versionArray[1]) >= minVersionArray[1]) {
        return true;
    } else {
        return false;
    }
}

/**
 * 前面补零
 * @param {*} num
 */
export function fillZero(num) {
    if (num > 9) {
        return `${num}`;
    } else {
        return `0${num}`;
    }
}

/**
 * 对秒数进行格式化
 * @param {*} time
 */
export function timeFormat(time) {
    let timeMunites = Math.floor(time / 60);
    let timeSeconds = Math.round(time - timeMunites * 60);
    let munites = fillZero(timeMunites);
    let seconds = fillZero(timeSeconds);
    return { munites, seconds };
}

export function noop() {}

//倒计时
export function timeDown({ time, count, done }) {
    if (time === 0) {
        done();
        return;
    }
    count(time);
    setTimeout(() => {
        time--;
        timeDown({ time, count, done });
    }, 1000);
}

// 获取当前url上的查询参数
export function getQueryString(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
}

// 获取元素的scrollTop
export function getScrollTop(element) {
    if (element === window) {
        return Math.max(window.pageYOffset || 0, document.documentElement.scrollTop);
    }
    return element.scrollTop;
}

//设置scrollTop
export function setScrollTop(element, scrollTop) {
    'scrollTop' in element ? (element.scrollTop = scrollTop) : element.scrollTo(element.scrollX, scrollTop);
}

export function jsonParse(str, defaultValue = {}) {
    try {
        let obj = JSON.parse(str);
        return obj;
    } catch (error) {
        return defaultValue;
    }
}
